import { Brand } from '@blade/std-lib'

import type { WalletAddress } from '@root/entities/wallet'

export const MakerAddressTypeId = 'tradebot-tma/MakerAddress' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MakerAddressTypeId = typeof MakerAddressTypeId

export type MakerAddress = Brand.Branded<WalletAddress, MakerAddressTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MakerAddress = Brand.nominal<MakerAddress>()
